// src/components/layout/TestimonialsSection.js
import React, { useEffect, useRef, useState } from 'react';
import '../../styles/testimonials.css';

const TestimonialsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  // Scroll Detection Logic
// Find your useEffect block and replace it with this:

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // CHANGED: threshold 0.1 means it triggers as soon as 10% is visible (starts earlier)
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); 
        }
      },
      { threshold: 0.1 } 
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const testimonials = [
    {
      id: 1,
      name: "Himani Dhiman",
      college: "Now studying at UPES",
      rating: 5,
      text: "It has been an invaluable resource for our family. Their team provided personalized guidance and support, helping us find the right college."
    },
    {
      id: 2,
      name: "Akhil Dhasmana",
      college: "Now at Graphic Era",
      rating: 5,
      text: "I would absolutely recommend CollegeAggregator. Best college counselling in Dehradun regarding fees and placement queries."
    },
    {
      id: 3,
      name: "Hemant Singh",
      college: "Now studying at UIT",
      rating: 5,
      text: "College Aggregator was introduced by my friend. They provided me a career map to start from college and proper guidance."
    },
    {
      id: 4,
      name: "Srishti Rawat",
      college: "Now at DBBU",
      rating: 5,
      text: "I was confused between CSE and IT. The counselors clarified everything and got me a scholarship seat. Truly grateful!"
    },
    {
      id: 5,
      name: "Rahul Verma",
      college: "Now at DIT University",
      rating: 4,
      text: "Great experience. They know the inside details of admission processes which helped me save a lot of time and effort."
    },
    {
      id: 6,
      name: "Priya Sharma",
      college: "Now at Tula's Institute",
      rating: 5,
      text: "Very professional team. They didn't just suggest colleges but analyzed my marks to find the best ROI options in Dehradun."
    },
    {
      id: 7,
      name: "Aryan Malhotra",
      college: "Now at Uttaranchal Univ.",
      rating: 5,
      text: "The fee structure transparency they provided was unmatched. No hidden charges, just honest advice."
    },
    {
      id: 8,
      name: "Simran Kaur",
      college: "Now at IMS Unison",
      rating: 5,
      text: "From application to final admission, they stood by me. Highly recommended for any student looking for management courses."
    }
  ];

  return (
    <section className="testimonials-section" ref={sectionRef}>
      <div className="testimonials-container">
        <div className={`testimonials-header ${isVisible ? 'fade-in-up' : ''}`}>
          <span className="testimonials-label">Student Success Stories</span>
          <h2 className="testimonials-title">How We Helped Students</h2>
          <p className="testimonials-subtitle">
            Real stories from students who found their perfect college through us
          </p>
        </div>

        {/* Added 'animate-grid' class conditionally */}
        <div className={`testimonials-grid ${isVisible ? 'animate-grid' : ''}`}>
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="testimonial-card-simple">
              <div className="quote-icon">"</div>
              
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="star">★</span>
                ))}
              </div>

              <p className="testimonial-text">{testimonial.text}</p>

              <div className="testimonial-author">
                <div className="author-info">
                  <h4 className="author-name">{testimonial.name}</h4>
                  <p className="author-college">{testimonial.college}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;